import { useAuth } from '../hooks/useAuth';

export default function Profile() {
  const { user, team, settings } = useAuth();
  const theme = document.documentElement.getAttribute('data-theme') ?? 'light';
  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    localStorage.setItem('theme', next);
  };
  return (
    <div className="page-wrap">
      <h2>Profile</h2>
      <div className="card" style={{ padding: 18, display: 'grid', gap: 8, maxWidth: 480 }}>
        <div>
          <span className="muted">Name: </span>
          {user?.full_name ?? '—'}
        </div>
        <div>
          <span className="muted">Email: </span>
          {user?.email ?? user?.email_address ?? '—'}
        </div>
        <div>
          <span className="muted">Role: </span>
          {user?.role ?? '—'}
        </div>
        <div>
          <span className="muted">Team: </span>
          {team?.name}
        </div>
        <div>
          <span className="muted">Invite code: </span>
          <code>{team?.invite_code}</code>
        </div>
        <div>
          <span className="muted">Curve points: </span>
          {settings?.freight_curve_n_points ?? 0}
        </div>
        <button className="btn" style={{ width: 'fit-content', marginTop: 8 }} onClick={toggleTheme}>
          Toggle {theme === 'dark' ? 'light' : 'dark'} mode
        </button>
      </div>
    </div>
  );
}
